import React, { useState } from "react";
import "../styles/ApplyForm.css";
import API_URL from "../apiConfig"; // Import the base API URL

export default function ApplyParamedicalForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    dob: "",
    address: "",
    qualification: "",
    paramedicalCourse: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);

    // Optional: Basic client validation
    for (const field in formData) {
      if (!formData[field]) {
        setErrorMsg("Please fill all fields.");
        setLoading(false);
        return;
      }
    }

    try {
      const response = await fetch(`${API_URL}/api/apply-paramedical`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        setSubmitted(true);
      } else {
        const data = await response.json().catch(() => ({}));
        setErrorMsg(data.error || "Failed to submit application");
      }
    } catch (error) {
      setErrorMsg("Server error! Please check your connection or try later.");
      console.log("Fetch error:", error);
    }
    setLoading(false);
  };

  return (
    <div className="apply-form-main">
      <div className="apply-form-container">
        <h2>Apply for Paramedical Course</h2>
        {submitted ? (
          <div className="success-message">Your application has been submitted!</div>
        ) : (
          <form onSubmit={handleSubmit} className="apply-form" autoComplete="off">
            <label htmlFor="name">Full Name</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <label htmlFor="dob">Date of Birth</label>
            <input
              type="date"
              id="dob"
              name="dob"
              placeholder="Date of Birth"
              value={formData.dob}
              onChange={handleChange}
              required
            />

            <label htmlFor="address">Address</label>
            <input
              type="text"
              id="address"
              name="address"
              placeholder="Address"
              value={formData.address}
              onChange={handleChange}
              required
            />

            <label htmlFor="qualification">Last Qualification</label>
            <input
              type="text"
              id="qualification"
              name="qualification"
              placeholder="Last Qualification"
              value={formData.qualification}
              onChange={handleChange}
              required
            />

            <label htmlFor="paramedicalCourse">Select Paramedical Course</label>
            <select
              id="paramedicalCourse"
              name="paramedicalCourse"
              value={formData.paramedicalCourse}
              onChange={handleChange}
              required
            >
              <option value="">Select Course</option>
              <option value="DMLT">DMLT</option>
              <option value="Physiotherapy">Physiotherapy</option>
              {/* Add more options here if needed */}
            </select>

            <button type="submit" disabled={loading || submitted}>
              {loading ? "Submitting..." : "Submit Application"}
            </button>
            {errorMsg && <div className="error-message">{errorMsg}</div>}
          </form>
        )}
      </div>
    </div>
  );
}